import { guestNotice } from "@oshimap/auth-core";
import { session } from "../lib/api";
import { Button, EmptyState, Skeleton } from "./ui";

/**
 * 로그인하지 않은 화면의 빈 상태.
 *
 * 네 화면이 각자 "로그인하면 …" 을 적고 있었습니다. 그러면 서버에 닿지 못해
 * 세션을 확인하지 못한 경우에도 같은 말을 하고, 사용자는 되지도 않을 로그인을
 * 시도합니다. 해석은 `guestNotice` 한 곳에서 하고, 화면은 자기 문구만 넘깁니다.
 *
 * 서버 문제일 때는 로그인 버튼을 주지 않습니다 — 눌러도 되지 않을 버튼을
 * 내미는 것은 안내가 아니라 헛걸음입니다.
 *
 * 세션 확인이 **아직 끝나지 않았을 때**도 로그인하라고 말하지 않습니다.
 * 화면들이 `status !== "authenticated"` 로 판단하는데 초기 상태가 `loading`
 * 이라서, 망이 느리면 로그인한 사람이 "로그인하면 …" 을 봤습니다. 서버를
 * 멈춰 놓고 확인했습니다 — 토큰이 있는데도 그랬습니다. 모르는 동안에는
 * 모른다고 보여 줍니다.
 */
export function GuestState({ signedOut, auth, prompt }: {
  signedOut: { title: string; body: string };
  auth: { require: (reason: string, run: () => void) => void };
  prompt?: string;
}) {
  if (session.state.status === "loading") return <Skeleton />;
  const notice = guestNotice(session.state, signedOut);
  const unreachable = notice !== signedOut;
  return <EmptyState
    title={notice.title}
    body={notice.body}
    action={unreachable ? undefined : (
      <Button variant="primary" size="sm"
        onClick={() => auth.require(prompt ?? signedOut.title, () => {})}>로그인</Button>
    )}
  />;
}
